var ReactGA = require('react-ga');
import { SAVE_EVENT_REQUEST } from "../actions/survey.actions";

export const analytics = store => next => action => {
    //let state = store.getState();
    
    switch (action.type) {
        case "@@router/LOCATION_CHANGE":
            let path = action.payload.location.pathname;
            ReactGA.pageview(path);
            break;
        case SAVE_EVENT_REQUEST:
            ReactGA.event({
                category: "Survey",
                action: action.type,
                label: "Submitted survey"
            });
            break;
        /*
        default:
            if (!action.type.toLowerCase().startsWith("rrf/")) {
                //ReactGA.event({ category: "Action", action: action.type });
            }*/
    }

    return next(action);
};
